import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import {
  Heading,
  ButtonIconContextual,
  BaseIcon,
  ButtonSecondary,
  SpinnerLoader,
  DataTable,
  BaseText
} from '@warrenbrasil/nebraska-web';

import { SideSheet } from '@/modules/common/components/SideSheet';
import {
  getNotifications,
  EAction,
  IRegisterNotification
} from '@/modules/home/services/register';
import { EDirection } from '@/modules/transaction/services/unified-account/enums';
import { StatementAvatarCell } from '@/modules/transaction/views/Transactions/components/StatementAvatarCell';
import VerifyEmailModal from '@/modules/home/components/HomeNotifications/components/VerifyEmailModal/VerifyEmailModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeRegister',
  props: {
  isOpen: {
    type: Boolean,
    default: false
  }
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props

const notificationsData = ref<IRegisterNotification[]>([]);
const isLoading = ref<boolean>(false);
const hasError = ref<boolean>(false);
const isEmpty = ref<boolean>(false);
const isOpenVerifyEmailModal = ref<boolean>(false);

const router = useRouter();
const route = useRoute();




watch(
  () => props.isOpen,
  async isOpen => {
    if (isOpen) {
      retry();
    }
  }
);

const retry = async () => {
  await fetchNotifications();
};

const fetchNotifications = async () => {
  try {
    isLoading.value = true;
    hasError.value = false;
    const data = await getNotifications();
    notificationsData.value = data.registerNotifications;
    isEmpty.value = data.registerNotifications.length === 0;
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};

const resetCentral = () => {
  notificationsData.value = [];
  isLoading.value = false;
  hasError.value = false;
  isEmpty.value = false;
};

const handleClose = () => {
  resetCentral();
  emit('close');
};

const handleClick = (notification: IRegisterNotification) => {
  console.log(notification);
  switch (notification.action) {
    case EAction.SUITABILITY:
      router.push({
        query: {
          ...route.query,
          suitabilityModal: 'true'
        }
      });
      break;
    case EAction.EMAIL:
      handleToggleVerifyEmailModal();
      break;
    default:
      break;
  }
};

const handleToggleVerifyEmailModal = () => {
  isOpenVerifyEmailModal.value = !isOpenVerifyEmailModal.value;
};

const columns = computed(() => {
  return [
    {
      width: '5%',
      component: StatementAvatarCell,
      getter: ({ icon }) => ({
        iconName: icon,
        size: 'medium',
        type: EDirection.Debit
      })
    },
    {
      width: '90%',
      getter: ({ title, description }) => ({
        text: title,
        description
      })
    },
    {
      width: '5%',
      type: 'icon',
      getter: () => ({
        icon: 'EA0170',
        ariaLabel: 'Detalhes'
      })
    }
  ];
});

return { __sfc: true,notificationsData, isLoading, hasError, isEmpty, isOpenVerifyEmailModal, router, route, emit, props, retry, fetchNotifications, resetCentral, handleClose, handleClick, handleToggleVerifyEmailModal, columns, Heading, ButtonIconContextual, BaseIcon, ButtonSecondary, SpinnerLoader, DataTable, BaseText, SideSheet, VerifyEmailModal }
}

})